import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import withReduxProvider from "web/react/redux-provider";
import { openCustomerCaptureOverlay } from "web/redux/ducks/customer-capture-overlay";
import PrimaryButton from "web/react/components/buttons/primary-button/primary-button";
import Button from "web/react/components/button/button";
import { gettext } from "web/script/modules/django-i18n";
import LeadLink from "web/react/components/lead-link/lead-link";
import environment from "web/script/modules/environment";
import userProfiler from "web/script/modules/userprofiler";

export function BuyOnStoreButton({
    leadUrl,
    leadLabel,
    openCustomerCaptureOverlay,
    productId,
    reason,
    features,
    beforeOnClick,
}) {
    function onClickBuyNow() {
        if (!userProfiler.isLoggedIn() && environment.get("boomLeadSignupPrompt")) {
            openCustomerCaptureOverlay({
                productId: productId,
                captureType: "signup_lead_save",
            });
        }
    }

    let button = (
        <PrimaryButton fullHeight fullWidth element="span">
            {leadLabel}
        </PrimaryButton>
    );
    let newColourScheme =
        typeof features !== "undefined" && features != null
            ? features.pmt_580_new_colour_scheme
            : null;

    if (newColourScheme) {
        button = (
            <Button styleType="secondary" fullHeight fullWidth element="span">
                {leadLabel}
            </Button>
        );
    }

    return (
        <LeadLink
            beforeOnClick={beforeOnClick}
            afterOnClick={onClickBuyNow}
            href={leadUrl}
            openInNewTab={true}
            productId={productId}
            reason={reason}
        >
            {button}
        </LeadLink>
    );
}

BuyOnStoreButton.propTypes = {
    leadLabel: PropTypes.string,
    leadUrl: PropTypes.string.isRequired,
    openCustomerCaptureOverlay: PropTypes.func,
    productId: PropTypes.string.isRequired,
    reason: PropTypes.string,
    features: PropTypes.object,
    beforeOnClick: PropTypes.func,
};

BuyOnStoreButton.defaultProps = {
    leadLabel: gettext("product.buy_area.shop_now"),
    reason: "buy-on-store-button",
};

export default withReduxProvider(connect(null, { openCustomerCaptureOverlay })(BuyOnStoreButton));
